<div class="flex flex-row gap-4 items-start mb-2">
    <div class="flex flex-col gap-2 w-full">
        <span class="text-sm font-semibold text-primary-500">{{ q.questionText }}</span>

        @if (questionTypeValue(q.questionType) === questionTypes.multipleChoice) {
        <div class="space-y-2">

            @for (opt of q.options; track $index; let optIdx = $index) {
            @let isCorrect = q.correctOptionId === opt.id;

            <div class="flex items-center gap-3 p-2 rounded-md border transition-colors duration-200"
                [class.bg-green-50]="isCorrect" [class.border-green-200]="isCorrect" [class.bg-gray-50]="!isCorrect"
                [class.border-gray-100]="!isCorrect">

                <input readonly type="checkbox" [name]="'correct-' + $index" [checked]="isCorrect"
                    class="h-4 w-4 rounded border-gray-300 text-green-500 bg-green-500 focus:bg-green-500 outline-none focus:outline-none focus:ring-0 focus:text-green-500">

                <input readonly class="flex-1 bg-transparent border-none focus:ring-0 text-sm py-1" [value]="opt.text"
                    [class.text-green-900]="isCorrect" [class.font-medium]="isCorrect">
            </div>
            }
        </div>
        } @else {
        <span
            class="w-full p-2 border border-gray-200 rounded text-sm focus:ring-2 focus:ring-secondary-500 outline-none">{{
            q.simpleAnswer }}</span>
        }
        <div class="flex flex-row justify-between items-center mt-2">
            <div class="flex flex-row gap-2">
                <app-chip label="{{ q.questionType | questionTypeLabel }}" [color]="chipColor.PRIMARY"></app-chip>
                <app-chip label="{{ q.score + ' marks' }}" [color]="chipColor.LIGHT"></app-chip>
                <app-chip class="titlecase"
                    label="{{ q.reference.book + ' ' + q.reference.chapter + (q.reference.verse ? ':' + q.reference.verse : '') }}"
                    [color]="chipColor.LIGHT"></app-chip>
            </div>
            <span class="text-xs text-gray-500">Modified: {{ q.modified | moment : 'Do MMM YYYY' }} </span>
        </div>
    </div>
    @if (isEditable) {
    <div class="flex flex-row gap-2">
        <app-btn-fab icon="fa fa-edit" (click)="editQuestion()"></app-btn-fab>
        <app-btn-fab icon="fa fa-trash" (click)="deleteQuestion()"
            textColor="text-red-500 disabled:text-gray-200"></app-btn-fab>
    </div>
    }
</div>